/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGCSInspections.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for GCS Inspection API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, April 03, 2019 - 04:09:39 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      04/03/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GCSInspections = {
    all: (assetid) => requests.get(`/GCSInspections?assetid=${assetid}`),
    get: gcsinspectionid => requests.get(`/GCSInspection/${gcsinspectionid}`),
    create: gcsinspection => requests.post(`/GCSInspections`, gcsinspection),
    update: (gcsinspectionid, gcsinspection) => requests.put(`/GCSInspection/${gcsinspectionid}`, gcsinspection),
    delete: gcsinspectionid => requests.del(`/GCSInspection/${gcsinspectionid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGCSInspections.js